import PowerOfUseGoals from "../../../../components/shared/PowerOfUseGoals/PowerOfUseGoals";

const ExtracreditPowerOfUse = ({ extracoinPercentage, userTypeInfo }) => {
  return (
    <div className="card border-round-md p-3" style={{ border: "1px solid var(--theme-border, #EBEBEB)" }}>
      <PowerOfUseGoals currentPercent={extracoinPercentage} userTypeInfo={userTypeInfo} />
    </div>
  );
};

export default ExtracreditPowerOfUse;
